import * as React from 'react';

const CmsEmpty = ({ component , page  })=>{
    const preview = page.isPreview();
    // This component should only render in CMS preview mode
    if (!preview) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", null, component === null || component === void 0 ? void 0 : component.getName());
};

export { CmsEmpty, CmsEmpty as default };
//# sourceMappingURL=Empty.js.map
